/*
 * As denúncias abertas do chat (ramon/chat: `chat-message-flags`), agrupadas
 * pela mensagem, para a fila "Revisar" (review/ReviewQueue.tsx) e o painel de
 * revisão do menu do usuário (usermenu/panels.tsx). No pacote principal, e
 * não num dos dois chunks, para os dois o usarem sem um chunk compartilhado
 * (que o Flarum não registraria).
 */
import app from 'flarum/forum/app';
import { chatReviewOn } from './flags';
/**
 * As denúncias abertas, uma entrada por mensagem. Recusado (403: o
 * ramon/chat de hoje só atende `ramon-chat.moderate`), devolve vazio sem
 * alerta — o pedido não foi do leitor.
 */
export async function loadChatReports() {
  if (!chatReviewOn()) return [];
  let results = [];
  try {
    results = await app.store.find('chat-message-flags', {
      filter: {
        resolved: '0'
      },
      sort: '-createdAt',
      page: {
        limit: 50
      }
    }, undefined, {
      errorHandler: error => error?.status === 401 || error?.status === 403 || error?.status === 404 ? undefined : false
    });
  } catch {
    return [];
  }
  const byMessage = new Map();
  Array.from(results || []).forEach(flag => {
    const message = flag.message?.();
    if (!message) return;
    const key = `chat-${message.id()}`;
    const date = flag.createdAt?.() || new Date(0);
    const entry = byMessage.get(key);
    if (entry) {
      entry.flags.push(flag);
      if (date > entry.date) entry.date = date;
    } else {
      byMessage.set(key, {
        key,
        message,
        flags: [flag],
        date
      });
    }
  });
  return Array.from(byMessage.values());
}

/** A fila "Revisar" já filtrada nas denúncias do chat, quando elas estão nela. */
export function reviewHref() {
  return chatReviewOn() && app.routes['flags'] ? app.route('flags', {
    type: 'chat'
  }) : null;
}
flarum.reg.add('ramon-canela', 'forum/thirdparty/ramonChat/features/reviewData', { reviewHref: reviewHref, });